import React from 'react';
import { services } from '../data/services';

const Services = () => {
  return (
    <section id="services" className="section-padding services-bg">
      <div className="container-xl">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold text-slate-600 uppercase tracking-wide mb-4">
            Our Services
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl logo-font text-gray-900 mb-6">
            Complete ICT Solutions for Modern Businesses
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-slate-800 to-slate-600 mx-auto rounded-full mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive technology solutions tailored to help your business grow and succeed in the digital age.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-8 xl:gap-10 2xl:gap-12">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative rounded-3xl border border-neutral-200/60 shadow-lg hover:shadow-2xl transition-all duration-500 p-8 xl:p-10 2xl:p-12 bg-white hover:-translate-y-3 overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Hover Background Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-800/5 via-slate-700/5 to-slate-900/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              
              {/* Icon */}
              <div className="relative w-16 h-16 xl:w-20 xl:h-20 bg-gradient-to-br from-slate-100 to-slate-200 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-gradient-to-br group-hover:from-slate-800 group-hover:to-slate-900 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3">
                <svg
                  className="w-8 h-8 xl:w-10 xl:h-10 text-slate-800 group-hover:text-white transition-colors duration-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={service.icon}
                  />
                </svg>
              </div>

              {/* Content */}
              <div className="relative space-y-6">
                <h3 className="text-xl xl:text-2xl font-bold text-gray-900 group-hover:text-slate-800 transition-colors duration-500">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-500 text-base xl:text-lg">
                  {service.description}
                </p>

                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start space-x-3">
                      <div className="w-1.5 h-1.5 bg-slate-800 rounded-full mt-2 flex-shrink-0 group-hover:bg-slate-600 transition-colors duration-300"></div>
                      <span className="text-sm text-gray-700 group-hover:text-gray-800 transition-colors duration-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Border highlight effect */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-slate-800/20 transition-all duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-6">
            Need a custom solution? We build tailored systems for your specific requirements.
          </p>
            <button
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium bg-slate-800 text-white hover:bg-slate-900 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-slate-700 focus:ring-offset-2"
            >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            Discuss Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
